import { useEffect } from "react";

export const PRESENCE_UPDATE_EVENT = "presence-update";

const getPresenceSocketUrl = () => {
    const configuredApiUrl = process.env.REACT_APP_API_ENDPOINT;
    const apiUrl = new URL(
        configuredApiUrl || window.location.origin,
        window.location.origin
    );
    apiUrl.protocol = apiUrl.protocol === "https:" ? "wss:" : "ws:";
    apiUrl.pathname = `${apiUrl.pathname.replace(/\/+$/, "")}/ws/presence`;
    apiUrl.search = "";
    apiUrl.hash = "";
    return apiUrl.toString();
};

export default function PresenceConnection({ user }) {
    useEffect(() => {
        if (!user?.id) return undefined;

        let socket;
        let heartbeatTimer;
        let reconnectTimer;
        let stopped = false;

        const currentStatus = () => document.visibilityState === "hidden" ? "AWAY" : "ACTIVE";
        const sendPresence = () => {
            if (socket?.readyState === WebSocket.OPEN) {
                socket.send(JSON.stringify({ status: currentStatus() }));
            }
        };

        const connect = () => {
            socket = new WebSocket(getPresenceSocketUrl());
            socket.addEventListener("open", () => {
                sendPresence();
                heartbeatTimer = window.setInterval(sendPresence, 30000);
            });
            socket.addEventListener("message", (event) => {
                try {
                    const update = JSON.parse(event.data);
                    if (update.type === "PRESENCE_UPDATE") {
                        window.dispatchEvent(new CustomEvent(PRESENCE_UPDATE_EVENT, {detail: update}));
                    }
                } catch {
                    // Ignore messages that are not valid presence updates.
                }
            });
            socket.addEventListener("close", () => {
                window.clearInterval(heartbeatTimer);
                if (!stopped) {
                    reconnectTimer = window.setTimeout(connect, 5000);
                }
            });
            socket.addEventListener("error", () => {
                socket.close();
            });
        };

        connect();
        document.addEventListener("visibilitychange", sendPresence);
        window.addEventListener("focus", sendPresence);
        window.addEventListener("blur", sendPresence);

        return () => {
            stopped = true;
            window.clearInterval(heartbeatTimer);
            window.clearTimeout(reconnectTimer);
            document.removeEventListener("visibilitychange", sendPresence);
            window.removeEventListener("focus", sendPresence);
            window.removeEventListener("blur", sendPresence);
            socket?.close();
        };
    }, [user?.id]);

    return null;
}
